import React from 'react';

interface Props {
	Component: React.ComponentType<any>;
	[key: string]: any;
}

const CustomFormComponent = ({ Component, ...props }: Props) => {
	return <Component {...props} />;
};

export default CustomFormComponent;
